/*
 * Public API Surface of angular-switchery-ios
 */

export * from "./lib/ng-switchery-ios.component";
export * from "./lib/ng-switchery-ios.module";
